export const getEdokFormCount = (state) =>
    state.edok.forms.maxCount;